// test1016
(1016 && 0);
